import React, { useContext} from "react";
import Select from 'react-select';
import { ProductsContext } from "../context/products.context";

const OptionsDualCredit = (props) => {
 const { selectedFilterIndicatorSchool, setSelectedFilterIndicatorSchool, selectableSchools} = useContext(ProductsContext)
  const { isMulti } = props;

  const optionsSchools =

((selectableSchools && selectableSchools.map(e => ({value:e, label:e}))))

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      background: '#ffffff',
      // outline: '1px solid #dcdcdc',

      cursor:'pointer',
      '&:hover': {
        borderColor: '#818cf8',
      },

    //   background: '#4a499f',
      // borderColor: '#c4c4c4',
      // borderWidth: "1px",
      minHeight: '40px',
      height: '40px',
      outline: 'none',

      boxShadow: state.isFocused ? null : null,
    }),


    input: (provided, state) => ({
      ...provided,
      marginLeft: '2px',


    }),
  };




  const handleRemoveStudentGroup = (e) => {
    if (!setSelectedFilterIndicatorSchool) return;
    const { name: buttonName } = e.currentTarget;
    const removedValue = selectedFilterIndicatorSchool.find((val) => val.value === buttonName);
    if (!removedValue) return;
    setSelectedFilterIndicatorSchool(
      selectedFilterIndicatorSchool.filter((val) => val.value !== buttonName),
      { action: "remove-value", removedValue }
    );
  };

  return (
    <div >

<div className="inline-block">
<span className="text-sm font-medium">Select School:</span>
        <Select className='ml-2 min-w-[275px]'  {...props} controlShouldRenderValue={!isMulti}
maxMenuHeight={800}

components={{ DropdownIndicator:() => (
  <div className="pr-2 text-gray-400"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5">
  <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 15L12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9" />
</svg>
</div>
), IndicatorSeparator:() => null }}
onChange={setSelectedFilterIndicatorSchool}
options={optionsSchools}
value={selectedFilterIndicatorSchool}
      styles={customStyles}
      isClearable={false}
      placeholder={
        <div className='flex flex-row items-center text-gray-700'><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5">
        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm.75-11.25a.75.75 0 00-1.5 0v2.5h-2.5a.75.75 0 000 1.5h2.5v2.5a.75.75 0 001.5 0v-2.5h2.5a.75.75 0 000-1.5h-2.5v-2.5z" clipRule="evenodd" />
      </svg>
      <span className='pl-2  w-[245px]'>Add student group to view</span>
      </div>}

       />

        {selectedFilterIndicatorSchool.length > 0 &&
        <div className="pl-6 -mt-6 ">
        <span className="font-xs text-gray-400 ">Student groups currently selected:</span>
        <div className='flex text-sm flex-wrap items-center'>

         {isMulti
           ? selectedFilterIndicatorSchool.map((val) => (
               <button
               name={val.value} onClick={handleRemoveStudentGroup}
               className=" hover:text-blue-700 group p-2 px-4 m-1 font-light bg-blue-100/60 text-black select-none rounded-md"
               key={val.value}>
                 {val.label}
                 <span
                 className=" text-black cursor-pointer pl-3 font-bold group-hover:text-blue-700"
                 >
                   ✕
                 </span>
               </button>
             ))
           : null}       <button
           onClick={() => setSelectedFilterIndicatorSchool([])}

           className="text-blue-500 no-underline hover:underline p-2 m-1 text-xs">CLEAR ALL
           </button> </div>
       </div>}</div>



       </div>







  );
};


// <button
// onClick={() => setSelectedFilterIndicatorSchool([])}
// disabled={!value.length > 0}
// className={`${value.length > 0 ? "text-blue-500 no-underline hover:underline" : "no-underline text-gray-400"}  px-[6px] text-xs`}>CLEAR ALL
// </button>


export default OptionsDualCredit;
